import { useMemo } from 'react';

import BaseSelect from 'lib/BaseSelect';
import { CodeNameModel } from 'components/common/types';
import { findOption } from 'lib/BaseSelect/utils';
import usePendoTracking from 'customHooks/usePendoTracking';
import { FilterStatusProps } from './FilterStatus.types';

const FilterStatus: React.FC<FilterStatusProps> = ({
  status = '',
  changeFilters,
  statusesList,
  keyName = 'status',
}) => {
  const selectedStatus = useMemo(() => findOption(statusesList, 'code', status), [status, statusesList]);

  const { getPendoDataId } = usePendoTracking(window.location.pathname);

  return (
    <BaseSelect
      dataTestId="status-select"
      name={keyName}
      options={statusesList}
      selectedValue={selectedStatus}
      onSelect={(_, value: CodeNameModel) => changeFilters({ [keyName]: value?.code })}
      placeholder="Select status"
      isClearable
      dataPendoId={getPendoDataId('Status filter')}
    />
  );
};

export default FilterStatus;
